import { render, staticRenderFns } from "./AssignRoom.vue?vue&type=template&id=297e0552&scoped=true&"
import script from "./AssignRoom.vue?vue&type=script&lang=js&"
export * from "./AssignRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297e0552",
  null
  
)

export default component.exports